
import { Link } from 'react-router-dom';
import { brands } from '../../mocks/brands';
import AnnouncementBar from '../../components/feature/AnnouncementBar';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CatalogPage() {
  return (
    <div className="min-h-screen bg-white">
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: "url('https://public.readdy.ai/ai/img_res/aa0d6bd8a45a8e34a85c69e1ec83f951.jpg')"
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
          </div>
          <div className="relative z-10 text-center w-full px-4">
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-white mb-4">
              NUESTRO CATÁLOGO
            </h1>
            <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto">
              Descubre todas las marcas profesionales que tenemos para ti
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">Inicio</Link>
            <i className="ri-arrow-right-s-line text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-stone-900 font-medium">Catálogo</span>
          </nav>
        </div>

        {/* Brands Grid */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-8">
          <h2 className="text-2xl font-serif font-bold text-stone-900 mb-2 text-center">
            ELIGE TU MARCA FAVORITA
          </h2>
          <p className="text-stone-500 text-sm text-center mb-12 max-w-xl mx-auto">
            Selecciona una marca para ver todos sus productos y colores disponibles
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {brands.map((brand) => (
              <Link
                key={brand.id}
                to={brand.id === 'luna-moon' ? '/catalogo/luna-moon' : '#'}
                className="group cursor-pointer"
              >
                <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-400 border border-stone-100">
                  <div className="relative w-full h-56 overflow-hidden">
                    <img
                      src={brand.image}
                      alt={brand.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-lg font-bold text-stone-900 group-hover:text-stone-600 transition-colors">
                        {brand.name}
                      </h3>
                      <span className="text-xs text-stone-400 bg-stone-50 px-3 py-1 rounded-full whitespace-nowrap">
                        {brand.productCount} productos
                      </span>
                    </div>
                    <p className="text-stone-500 text-sm mb-4">{brand.description}</p>
                    <div className="flex items-center gap-2 text-sm font-medium text-stone-900 group-hover:text-stone-600 transition-colors">
                      <span>Ver colección</span>
                      <i className="ri-arrow-right-line text-base w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
